import { Route, Routes } from "react-router-dom";
import Login from "./pages/Login.jsx";
import ProtectedRoutes from "./components/ProtectedRoutes.jsx";
import ProtectedRoutesMobile from "./components/ProtectedRoutesMobile.jsx";
import UploadRequests from "./components/UploadRequests.jsx";
import NewUploadRequests from "./components/NewUploadRequests.jsx";
import Withdrawals2 from "./pages/Withdrawals2.jsx";
import WarehouseInventory from "./pages/WarehouseInventory.jsx";
import OrdersNew from "./pages/OrdersNew.jsx";
import OrderDetail from "./pages/OrderDetail.jsx";
import PendingOrders from "./pages/PendingOrders.jsx";
import ClickAndCollect from "./pages/ClickAndCollect.jsx";
import SuccessUpload from "./components/SuccessUpload.jsx";
import ProcessOrder from "./pages/ProcessOrder.jsx";
import SuccessProcess from "./components/SuccessProcess.jsx";
import Mailing from "./pages/Mailing.jsx";
import MailingConfig from "./pages/MailingConfig.jsx";
import SellerInventory from "./pages/SellerInventory.jsx";
import ProductDetail from "./pages/ProductDetail.jsx";
import UploadProducts from "./pages/UploadProducts.jsx";
import DeliveriesResume from "./pages/DeliveriesResume.jsx";
import Dashboard from "./pages/Dashboard.jsx";
import TrackOrder from "./pages/TrackOrder.jsx";
import MySellers from "./pages/MySellers.jsx";
import SellerDetail from "./pages/CompanyDetail.jsx";
import EcommerceConfiguration from "./pages/EcommerceConfiguration.jsx";
import WebhookConfiguration from "./pages/WebhookConfiguration.jsx";
import CreateSeller from "./pages/CreateSeller.jsx";
import Picking from "./pages/Picking";
import MyRoutes from "./pages/drivers/MyRoutes.jsx";
import RouteDetail from "./pages/drivers/RouteDetail.jsx";
import MyDrivers from "./pages/drivers/MyDrivers.jsx";
import MyAccount from "./pages/MyAccount.jsx";
import Tracking from "./pages/Tracking.jsx";
import ShippingZone from "./pages/ShippingZone.jsx";
import ShippingZoneDetail from "./pages/ShippingZoneDetail.jsx";
import Partnership from "./pages/Partnership.jsx";
import DeliveryUpsell from "./pages/DeliveryUpsell.jsx";
import AdminSettingCourier from "./pages/AdminSettingCourier.jsx";
import AdminExternalIntegration from "./pages/AdminExternalIntegration.jsx";
import MyAdmins from "./pages/MyAdmins.jsx";
import AdminDetail from "./pages/AdminDetail.jsx";
import CreatePickupRequest from "./pages/CreatePickupRequest.jsx";
import AssignToManifest from "./pages/AssignToManifest.jsx";

import TrackingGT from "./pages/TrackingGT.jsx";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/tracking/" element={<Tracking />} />
      <Route path="/globaltracking/tracking/" element={<TrackingGT />} />
      <Route path="/track-order/:orderId" element={<TrackOrder />} />
      <Route
        path="/home/*"
        element={
          <ProtectedRoutes>
            <Routes>
              <Route path="my-account" element={<MyAccount />} />
              <Route path="withdrawals" element={<Withdrawals2 />} />
              <Route
                path="orders"
                element={<OrdersNew daysOffset={3} mode="operator" />}
              />
              <Route
                path="orders/seller"
                element={<OrdersNew daysOffset={3} mode="seller" />}
              />
              <Route path="/upload-requests" element={<NewUploadRequests />} />
              <Route
                path="/warehouse-inventory"
                element={<WarehouseInventory />}
              />
              <Route path="/seller-inventory" element={<SellerInventory />} />
              <Route path="/order-details/:orderId" element={<OrderDetail />} />
              <Route
                path="/pending-orders"
                element={<PendingOrders daysOffset={10} />}
              />
              <Route
                path="/click-and-collect"
                element={
                  <ClickAndCollect
                    key="click-and-collect"
                    daysOffset={10}
                    isPickUp={false}
                  />
                }
              />
              <Route
                path="/pick-up"
                element={
                  <ClickAndCollect
                    key="pick-up"
                    daysOffset={20}
                    isPickUp={true}
                  />
                }
              />
              <Route
                path="/upload-success-order"
                element={<SuccessUpload mode="order" />}
              />
              <Route
                path="/upload-success-product"
                element={<SuccessUpload mode="product" />}
              />
              <Route
                path="/process-order/:orderId"
                element={<ProcessOrder />}
              />
              <Route path="/process-success" element={<SuccessProcess />} />
              <Route path="mailing" element={<Mailing />} />
              <Route path="mailing-config" element={<MailingConfig />} />
              <Route
                path="/inventory-details/:productId"
                element={<ProductDetail />}
              />
              <Route
                path="/seller-create-product"
                element={<UploadProducts />}
              />
              <Route
                path="/deliveries-resume"
                element={<DeliveriesResume daysOffset={3} />}
              />
              <Route path="/pickings" element={<Picking />} />
              <Route path="/dashboard" element={<Dashboard daysOffset={3} />} />
              <Route path="/my-sellers" element={<MySellers />} />
              <Route path="/my-admins" element={<MyAdmins />} />
              <Route path="/admin/:adminId" element={<AdminDetail />} />
              <Route path="/my-shipping-zones" element={<ShippingZone />} />
              <Route
                path="/my-shipping-zones/:zoneId/detail"
                element={<ShippingZoneDetail />}
              />

              <Route path="/my-partnerships" element={<Partnership />} />
              <Route path="/upselling/incoming" element={<DeliveryUpsell />} />

              <Route path="/my-providers-credentials" element={<AdminSettingCourier />} />
              <Route path="/external-integrations" element={<AdminExternalIntegration />} />

              <Route path="/company/:companyId" element={<SellerDetail />} />
              <Route
                path="/configuration/ecommerce"
                element={<EcommerceConfiguration />}
              />
              <Route
                path="/configuration/webhooks"
                element={<WebhookConfiguration />}
              />
              <Route path="/create-seller" element={<CreateSeller />} />
              <Route path="/pickup-requests/create" element={<CreatePickupRequest />} />
              <Route path="/pickup-requests/assign" element={<AssignToManifest />} />
            </Routes>
          </ProtectedRoutes>
        }
      />
      <Route
        path="/admin_checkout/*"
        element={
          <ProtectedRoutes>
            <Routes>
              <Route path="my-account" element={<MyAccount />} />
              <Route path="/dashboard" element={<Dashboard daysOffset={3} />} />
              <Route
                path="/delivery-resume"
                element={<DeliveriesResume daysOffset={3} />}
              />
              <Route path="/upload-requests" element={<NewUploadRequests />} />
              <Route path="/sellers" element={<MySellers />} />
              <Route path="/drivers" element={<MyDrivers />} />
            </Routes>
          </ProtectedRoutes>
        }
      />
      <Route
        path="/driver/*"
        element={
          <ProtectedRoutesMobile>
            <Routes>
              <Route path="my-account" element={<MyAccount />} />
              <Route path="my-routes" element={<MyRoutes />} />
              <Route path="my-routes/:deliveryId" element={<RouteDetail />} />
            </Routes>
          </ProtectedRoutesMobile>
        }
      />
    </Routes>
  );
}

export default App;
